// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-expansion-panels .v-expansion-panel-header__icon i{font-size:20px!important}.set-top-border{border-top:1px solid #d3d3d3}.v-expansion-panel-header{height:30px!important;padding:0 8px!important}.v-expansion-panel--active>.v-expansion-panel-header{min-height:30px!important}.v-expansion-panel-content__wrap{padding:0 4px!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
